var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wrapper',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"space-y-4"},[_c('div',{staticClass:"flex items-center justify-end gap-2"},[_c('base-select',{attrs:{"options":[
          {
            key: 'pusat',
            label: 'Pusat',
            value: 'pusat',
          },
          {
            key: 'kantor_pelayanan',
            label: 'Kantor Pelayanan',
            value: 'kantor_pelayanan',
          },
          {
            key: 'stockist_center',
            label: 'Stockist Center',
            value: 'stockist_center',
          },
          { key: 'stockist', label: 'Stockist', value: 'stockist' },
        ],"shadow":false},model:{value:(_vm.filter.officeType),callback:function ($$v) {_vm.$set(_vm.filter, "officeType", $$v)},expression:"filter.officeType"}}),_c('base-button',{attrs:{"loading":_vm.loadingProcess.visible},on:{"click":_vm.onProcess}},[_vm._v(_vm._s(_vm.loadingProcess.visible ? _vm.loadingProcessLabel : 'Export'))])],1),_c('Datatable',{attrs:{"total":_vm.histories.meta.page.total,"perPage":_vm.histories.meta.page.perPage,"currentPage":_vm.histories.meta.page.currentPage,"columns":[
        { id: 'date', name: 'Tanggal' },
        { id: 'user', name: 'User' },
        { id: 'status', name: 'Status', theadClass: 'text-center' },
        {
          id: 'download',
          name: 'Download Export',
          theadClass: 'text-center',
        },
      ]},on:{"pagechanged":_vm.onChangeHistoryPage},scopedSlots:_vm._u([{key:"tbody",fn:function({ classes }){return _vm._l((_vm.histories.data),function(history){return _c('tr',{key:history.id,class:[classes.tr, 'bg-white']},[_c('td',{class:classes.td},[_vm._v(" "+_vm._s(_vm._f("formatDate")(history.attributes.createdAt))+" ")]),_c('td',{class:classes.td},[_vm._v(_vm._s(history.attributes.user_email))]),_c('td',{class:[classes.td, 'text-center']},[(!history.attributes.finishedAt)?_c('BaseBadge',{attrs:{"color":"yellow"}},[_vm._v("Sedang Diproses")]):_c('BaseBadge',{attrs:{"color":"green"}},[_vm._v("Selesai")])],1),_c('td',{class:[classes.td, 'text-center']},[(history.attributes.file_url)?_c('a',{staticClass:"flex justify-center text-green-600",attrs:{"href":history.attributes.file_url}},[_c('Icon',{staticClass:"h-4 w-4",attrs:{"icon":"heroicons:arrow-down-tray"}})],1):_vm._e()])])})}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }